import React from 'react';
import classnames from 'classnames';
import { baseXUnit, breakpoints } from '../../styles/theme';
import { defaultNavbarHeight } from '../navigation/DefaultNavbar';

interface StickyColProps {
  contentTopOffset: number;
  className?: string;
}
const StickyCol: React.FunctionComponent<
  StickyColProps & React.HTMLAttributes<HTMLElement>
> = ({ contentTopOffset, className, children, ...rest }) => {
  return (
    <div className={classnames('sticky-column', className)} {...rest}>
      {children}
      {/*language=CSS*/}
      <style jsx>{`
        .sticky-column {
          position: sticky;
          top: ${baseXUnit(defaultNavbarHeight + contentTopOffset)};
        }

        @media ${breakpoints.large} {
          .sticky-column {
            /* Add some padding to the bottom so that the side bar text will exit the screen slightly before scrolling
               to the end of the column.
               Has to be inside a breakpoint so that the sticky column does not break the mobile layouts.
           */
            padding-bottom: ${baseXUnit(27)};
          }
        }
      `}</style>
    </div>
  );
};

export default StickyCol;
